// POST data loader
export const POST_DATALOADER_REQUEST = "POST_DATALOADER_REQUEST";
export const POST_DATALOADER_SUCCESS = "POST_DATALOADER_SUCCESS";
export const POST_DATALOADER_FAILURE = "POST_DATALOADER_FAILURE";
export const POST_DATALOADER_RESET = "POST_DATALOADER_RESET";

// PUT data loader
export const PUT_DATALOADER_REQUEST = "PUT_DATALOADER_REQUEST";
export const PUT_DATALOADER_SUCCESS = "PUT_DATALOADER_SUCCESS";
export const PUT_DATALOADER_FAILURE = "PUT_DATALOADER_FAILURE";
export const PUT_DATALOADER_RESET = "PUT_DATALOADER_RESET";

// GET data loaders
export const FETCH_LOADERS_LIST_REQUEST = "FETCH_LOADERS_LIST_REQUEST";
export const FETCH_LOADERS_LIST_SUCCESS = "FETCH_LOADERS_LIST_SUCCESS";
export const FETCH_LOADERS_LIST_FAILURE = "FETCH_LOADERS_LIST_FAILURE";

// GET data loader details
export const FETCH_LOADER_REQUEST = "FETCH_LOADER_REQUEST";
export const FETCH_LOADER_SUCCESS = "FETCH_LOADER_SUCCESS";
export const FETCH_LOADER_FAILURE = "FETCH_LOADER_FAILURE";

// DELETE data loader
export const DELETE_LOADER_REQUEST = "DELETE_LOADER_REQUEST";
export const DELETE_LOADER_SUCCESS = "DELETE_LOADER_SUCCESS";
export const DELETE_LOADER_FAILURE = "DELETE_LOADER_FAILURE";

// Get Loader Status
export const FETCH_LOADER_STATUS_REQUEST = "FETCH_LOADER_STATUS_REQUEST";
export const FETCH_LOADER_STATUS_SUCCESS = "FETCH_LOADER_STATUS_SUCCESS";
export const FETCH_LOADER_STATUS_FAILURE = "FETCH_LOADER_STATUS_FAILURE";